import { render } from "./FilterMillsModal.vue?vue&type=template&id=2928b416&scoped=true"
import script from "./FilterMillsModal.vue?vue&type=script&lang=js"
export * from "./FilterMillsModal.vue?vue&type=script&lang=js"

import "./FilterMillsModal.vue?vue&type=style&index=0&id=2928b416&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2928b416"]])

export default __exports__